import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';
import { Button } from './button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './Dialog';
import { pushDialog } from './dialogs-store';
const getDialogIcon = (type) => {
    switch (type) {
        case 'error':
            return _jsx(XCircle, { className: "h-5 w-5 text-destructive" });
        case 'destructive':
            return _jsx(XCircle, { className: "h-5 w-5 text-destructive" });
        case 'success':
            return _jsx(CheckCircle, { className: "h-5 w-5 text-green-600" });
        case 'warning':
            return _jsx(AlertCircle, { className: "h-5 w-5 text-yellow-600" });
        case 'info':
        default:
            return _jsx(Info, { className: "h-5 w-5 text-blue-600" });
    }
};
const getDialogTitle = (type) => {
    switch (type) {
        case 'error':
            return 'Chyba';
        case 'success':
            return 'Úspěch';
        case 'warning':
            return 'Upozornění';
        case 'info':
        default:
            return 'Informace';
    }
};
export const useDialogs = () => {
    const alert = ({ message, type, title }) => {
        return new Promise(resolve => {
            const { close } = pushDialog(_jsx(Dialog, { open: true, onOpenChange: open => {
                    if (!open) {
                        close();
                        resolve();
                    }
                }, children: _jsxs(DialogContent, { children: [_jsxs(DialogHeader, { children: [_jsxs("div", { className: "flex items-center gap-3", children: [getDialogIcon(type), _jsx(DialogTitle, { children: title ?? getDialogTitle(type) })] }), _jsx(DialogDescription, { className: "text-left whitespace-pre-line", children: Array.isArray(message)
                                        ? message.map((m, index) => (_jsxs("span", { children: [m, index < message.length - 1 && _jsx("br", {})] }, index)))
                                        : message })] }), _jsx(DialogFooter, { className: "flex gap-2", children: _jsx(Button, { variant: type === 'error' ? 'destructive' : 'default', onClick: () => {
                                    close();
                                    resolve();
                                }, className: "w-full", children: "OK" }) })] }) }));
        });
    };
    const confirm = ({ message, type, title, confirmText, cancelText }) => {
        return new Promise(resolve => {
            const { close } = pushDialog(_jsx(Dialog, { open: true, onOpenChange: open => {
                    if (!open) {
                        close();
                        resolve(false);
                    }
                }, children: _jsxs(DialogContent, { children: [_jsx(DialogHeader, { children: _jsxs("div", { className: "flex items-center gap-3", children: [type === 'info' ? null : getDialogIcon(type), _jsx(DialogTitle, { children: title ?? getDialogTitle(type) })] }) }), _jsx("div", { className: "h-full", children: message ? _jsx(DialogDescription, { className: "text-left whitespace-pre-line", children: message }) : null }), _jsxs(DialogFooter, { className: "flex flex-col md:flex-row gap-2", children: [_jsx(Button, { variant: "outline", onClick: () => {
                                        close();
                                        resolve(false);
                                    }, className: "w-full", children: cancelText ?? 'Zrušit' }), _jsx("div", { className: "flex-none md:flex-1" }), _jsx(Button, { variant: type === 'error' || type === 'destructive' ? 'destructive' : 'default', onClick: () => {
                                        close();
                                        resolve(true);
                                    }, className: "w-full", children: confirmText ?? 'Potvrdit' })] })] }) }));
        });
    };
    function openCustomDialog(arg1, arg2) {
        let closeRef = null;
        let updateRef = null;
        const closeWithRefs = () => {
            if (closeRef) {
                closeRef();
            }
        };
        let element;
        if (typeof arg1 === 'function' && arg2 === undefined) {
            const renderFn = arg1;
            element = renderFn(closeWithRefs);
        }
        else {
            const Component = arg1;
            const props = arg2;
            element = _jsx(Component, { ...props, onClose: closeWithRefs });
        }
        const { close, update } = pushDialog(element);
        closeRef = close;
        updateRef = update;
        const bound = Object.assign(() => closeWithRefs(), { update: (c) => updateRef?.(c) });
        return bound;
    }
    return { alert, confirm, openCustomDialog };
};
//# sourceMappingURL=useDialogs.hook.js.map